import pimg1 from '../images/project/5.jpg';
import pimg2 from '../images/project/7.jpg';
import pimg3 from '../images/project/10.jpg';
import pimg4 from '../images/project/2.jpg';
import pimg5 from '../images/project/6.jpg';
import pimg6 from '../images/project/11.jpg';
import pimg7 from '../images/project/1.jpg';
import pimg8 from '../images/project/9.jpg';
import pimg9 from '../images/project/3.jpg';
import pimg10 from '../images/project/8.jpg';
import pimg11 from '../images/project/4.jpg';


import p2img1 from '../images/project/5.jpg';
import p2img2 from '../images/project/7.jpg'
import p2img3 from '../images/project/10.jpg'
import p2img4 from '../images/project/2.jpg';
import p2img5 from '../images/project/6.jpg'
import p2img6 from '../images/project/11.jpg'
import p2img7 from '../images/project/1.jpg'
import p2img8 from '../images/project/9.jpg'
import p2img9 from '../images/project/3.jpg'
import p2img10 from '../images/project/8.jpg'
import p2img11 from '../images/project/4.jpg'

import p3img1 from '../images/project-details/img-2.png'
import p3img2 from '../images/project-details/img-3.png'
import p3img3 from '../images/project-details/img-4.png'
import p3img4 from '../images/project-details/img-5.png'
import p3img5 from '../images/project-details/img-7.png'
import p3img6 from '../images/project-details/img-8.jpg'
import p3img7 from '../images/project-details/img-4.png'
import p3img8 from '../images/project-details/img-2.png'
import p3img9 from '../images/project-details/img-5.png'
import p3img10 from '../images/project-details/img-2.png'
import p3img11 from '../images/project-details/img-7.png'




const Projects = [
    {
        id: '01',
        subtitle: '17-19 Puckle St, Moonee Ponds',
        title: 'Penny Lane',
        docomunt: 'Located at Penny Lane 17-19 Puckle St, this project offers modern urban living with premium design and accessibility.',
        slug: 'moonee-ponds-penny-lane',
        pimg: pimg1,
        pSimg: p2img1,
        pSimg2: p3img1,
        location: 'Moonee Ponds, Australia',
        date: '15 Dec 2024',
    },
    {
        id: '02',
        subtitle: 'Seafarers Precinct',
        title: 'Melbourne',
        docomunt: 'Situated in Seafarers Precinct, this development features contemporary waterfront living with high-end finishes.',
        slug: 'melbourne-seafarers-precinct',
        pimg: pimg2,
        pSimg: p2img2,
        pSimg2: p3img2,
        location: 'Melbourne, Australia',
        date: '15 Dec 2024',
    },
    {
        id: '03',
        subtitle: 'Montague Square',
        title: 'South Melbourne',
        docomunt: 'Located in Montague Square, this project blends modern architecture with functional urban living spaces.',
        slug: 'south-melbourne-montague-square',
        pimg: pimg3,
        pSimg: p2img3,
        pSimg2: p3img3,
        location: 'South Melbourne, Australia',
        date: '15 Dec 2024',
    },

    {
        id: '04',
        subtitle: 'Greystar',
        title: 'South Melbourne',
        docomunt: 'Greystar project in South Melbourne delivers premium residential spaces with modern design and luxury amenities.',
        slug: 'south-melbourne-greystar',
        pimg: pimg4,
        pSimg: p2img4,
        pSimg2: p3img4,
        location: 'South Melbourne, Australia',
        date: '15 Dec 2024',
    },

    {
        id: '05',
        subtitle: '22 Johnston Street',
        title: 'Melbourne',
        docomunt: 'Located at 22 Johnston Street, this development combines modern living with a prime Melbourne location.',
        slug: 'melbourne-22-johnston-street',
        pimg: pimg5,
        pSimg: p2img5,
        pSimg2: p3img5,
        location: 'Melbourne, Australia',
        date: '15 Dec 2024',
    },
    {
        id: '06',
        subtitle: 'VACC Head Office',
        title: 'North Melbourne',
        docomunt: 'The VACC Head Office in North Melbourne is designed for modern corporate operations with a professional environment.',
        slug: 'north-melbourne-vacc-head-office',
        pimg: pimg6,
        pSimg: p2img6,
        pSimg2: p3img6,
        location: 'North Melbourne, Australia',
        date: '15 Dec 2024',
    },
    {
        id: '07',
        subtitle: '6 & 8 Parramatta Square',
        title: 'Sydney',
        docomunt: 'Located at 6 & 8 Parramatta Square, this project offers premium commercial spaces in a key Sydney business district.',
        slug: 'sydney-parramatta-square',
        pimg: pimg7,
        pSimg: p2img7,
        pSimg2: p3img7,
        location: 'Sydney, Australia',
        date: '15 Dec 2024',
    },
    {
        id: '08',
        subtitle: 'One Sydney Harbour',
        title: 'Barangaroo',
        docomunt: 'One Sydney Harbour in Barangaroo features luxury waterfront living with world-class architecture and views.',
        slug: 'barangaroo-one-sydney-harbour',
        pimg: pimg8,
        pSimg: p2img8,
        pSimg2: p3img8,
        location: 'Barangaroo, Sydney',
        date: '15 Dec 2024',
    },
    {
        id: '09',
        subtitle: 'M4 Westconnex Project',
        title: 'Sydney',
        docomunt: 'The M4 Westconnex Project enhances connectivity and transport infrastructure across Sydney.',
        slug: 'sydney-m4-westconnex',
        pimg: pimg9,
        pSimg: p2img9,
        pSimg2: p3img9,
        location: 'Sydney, Australia',
        date: '15 Dec 2024',
    },
    {
        id: '10',
        subtitle: 'St Peters Interchange',
        title: 'Sydney',
        docomunt: 'St Peters Interchange improves traffic flow and connectivity within Sydney’s major transport network.',
        slug: 'sydney-st-peters-interchange',
        pimg: pimg10,
        pSimg: p2img10,
        pSimg2: p3img10,
        location: 'Sydney, Australia',
        date: '15 Dec 2024',
    },
    {
        id: '11',
        subtitle: 'Crown Resort Sydney',
        title: 'Barangaroo',
        docomunt: 'Crown Resort Sydney in Barangaroo delivers luxury hospitality, entertainment, and iconic architectural design.',
        slug: 'barangaroo-crown-resort-sydney',
        pimg: pimg11,
        pSimg: p2img11,
        pSimg2: p3img11,
        location: 'Barangaroo, Sydney',
        date: '15 Dec 2024',
    },

]
export default Projects;